<template>
    <div>
        <h3 class="om-page-heading">
            <label for="search">{{ $tr('Lista odbiorów', 'CollectList') }}</label>
        </h3>
        <form class="om-search flex sb">
            <input id="search" v-model="searchValue" class="om-search__input fg-20" :placeholder="$tr('Imię i nazwisko lub numer zamówienia', 'CollectList')" :title="$tr('Imię i nazwisko lub numer zamówienia', 'CollectList')">
            <button
              class="om-btn om-search__submit"
              :placeholder="$tr('', 'CollectList')"
              @click.prevent="searchAction"
              type="submit">
                {{ $tr('Szukaj', 'CollectList') }}
            </button>
        </form>
        <div class="om-list-heading flex sb">
            <div v-if="search != ''" class="flex wrap">
                <div class="om-list-heading__label om-list-heading__label--bright">{{ $tr('Wyniki wyszukiwania:', 'CollectList') }}</div>
                <div class="om-list-heading__label">{{ search }}</div>
                <div class="om-list-heading__label om-list-heading__label--num">({{ filteredCount }})</div>
            </div>
            <div class="flex wrap">
                <label class="om-list-heading__label">{{ $tr('Pokaż', 'CollectList') }}</label>
                <dropdown v-on:change="changePerPage" :items="itemsPerPage" :default-label="defaultPerPage.name" :default-value="defaultPerPage.value"></dropdown>
            </div>
            <div v-if="storesDefaultFilter" class="flex wrap">
              <label class="om-list-heading__label">{{ $tr('Sklep', 'CollectList') }}</label>
              <dropdown v-on:change="changeFilterByStore" :items="storesFilter" :default-label="storesDefaultFilter.name" :default-value="storesDefaultFilter.value"></dropdown>
            </div>
            <radio :items="dateRangesFilter" v-on:change="changeDateRange"></radio>
            <div class="flex wrap">
                <label class="om-list-heading__label">{{ $tr('Wyświetl:', 'CollectList') }}</label>
                <dropdown
                  v-on:change="changeFilterByState"
                  :items="filterByStates"
                  :default-label="defaultByStates.name"
                  :default-value="defaultByStates.value"></dropdown>
            </div>
        </div>

        <table v-if="!noContent" class="om-table">
            <thead>
            <tr>
                <th>{{ columns.reference }}</th>
                <th>{{ columns.shop }}</th>
                <th>{{ columns.name }}</th>
                <th>{{ columns.data }}</th>
                <th>{{ columns.status }}</th>
                <th></th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="item in pageContent">
                <td class="reference">{{ item.reference }}</td>
                <td>
                    <!--{{ $moment(item.date).format('DD.MM.YYYY') }}-->
                    {{ typeof item.store_collect !== 'undefined' ? item.store_collect.name : '' }}
                </td>
                <td>
                    <div class="font-normal" v-html="highlight(item.firstname + ' ' + item.lastname, search)"></div>
                </td>
                <td>
                    <div>{{ item.email }}</div>
                    <div>{{ item.phone }}</div>
                </td>
                <td class="status" :style="{color: item.statusColor}">{{ item.status }}</td>
                <td class="more">
                    <router-link :to="{name: 'Collect', params: {reference: item.reference}}">
                        <i class="om-ico-zoom" aria-hidden="true"></i>
                    </router-link>
                </td>

            </tr>
            </tbody>

        </table>
        <div v-else="" class="om-information">
          {{ $tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'CollectList') }}
        </div>
        <div class="om-list-footer flex sb">
            <div></div>
            <paginator
              :items-per-page="currentPerPage"
              v-on:change="updatePageContent"
              :request="requestParams"
              :update-force="requestUpdateForce"
              :passive-mode="true"></paginator>
        </div>
    </div>
</template>

<script>
  import Paginator from '../reusable/paginator/Paginator.vue'
  import dateRangesMixin from '../../mixins/date-ranges'

  export default {
    mixins: [dateRangesMixin],
    components: {Paginator},
    name: 'collect-list',
    data () {
      return {
        list: [],
        defaultPerPage: {name: 3, value: 3},
        itemsPerPage: [{name: 3, value: 3}, {name: 6, value: 6}, {name: 12, value: 12}, {name: 24, value: 24}, {name: 48, value: 48}],
        currentPerPage: 3,
        filterByStates: [],
        defaultByStates: {},
        pageContent: [],
        filteredCount: 1,
        fList: null,
        periodsRadioFilter: null,
          /* table sort functionality */
        sortKey: 'name',

        reverse: false,

        searchValue: '',
        search: '',

        columns: {},
        paginatorPassive: true,
        requestParams: {
          route: 'collect-list',
          params: {}
        },
        requestUpdateForce: 1,
        // filter by stores
        storesFilter: [],
        storesDefaultFilter: null
      }
    },
    mounted () {
      this.columns = {
        'reference': this.$tr('Nr zamówienia', 'CollectList'),
        'shop': this.$tr('Sklep', 'CollectList'),
        'date': this.$tr('Data', 'CollectList'),
        'name': this.$tr('Imię i nazwisko', 'CollectList'),
        'data': this.$tr('Dane kontaktowe', 'CollectList'),
        'status': this.$tr('Status zamówienia', 'CollectList')
      }
      this.defaultByStates = {name: this.$tr('Wszystkie odbiory', 'CollectList'), value: null}
      this.filterByStates.push(this.defaultByStates)
      this.$http.get(this.$router.options.getApiRoute('collect-states'))
      .then((r) => {
        let statesFilters = r.body.states.map((el, key) => {
          return {
            name: el,
            value: el
          }
        })
        this.filterByStates = this.filterByStates.concat(statesFilters)
      })
      let initialStoreFilter = {
        name: this.$tr('--', 'ReturnList'),
        value: null
      }
      this.storesDefaultFilter = initialStoreFilter
      this.storesFilter.push(initialStoreFilter)
      this.$http.get(this.$router.options.getApiRoute('collect-stores'))
      .then((resp) => {
        if (resp.ok) {
          let storesFilter = resp.body.stores.map((el, key) => {
            return {
              name: el.name,
              value: el
            }
          })
          this.storesFilter = this.storesFilter.concat(storesFilter)
        }
      })
    },
    methods: {
      changePerPage (ev) {
        this.currentPerPage = ev
      },
      changeFilterByState (val, filterkey) {
        filterkey = typeof filterkey !== 'undefined' ? filterkey : 'status'
        if (val !== null) {
          if (typeof this.requestParams.params['filter'] !== 'object') {
            this.requestParams.params['filter'] = {}
          }
          this.requestParams.params.filter['status'] = val
        } else {
          if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['status'] !== 'undefined') {
            delete this.requestParams.params['filter']['status']
          }
        }
        this.requestUpdateForce++
      },
      changeFilterByStore (val) {
        if (val !== null) {
          if (typeof this.requestParams.params['filter'] !== 'object') {
            this.requestParams.params['filter'] = {}
          }
          this.requestParams.params.filter['shop'] = val
        } else {
          if (typeof this.requestParams.params['filter'] !== 'undefined' && typeof this.requestParams.params['filter']['shop'] !== 'undefined') {
            delete this.requestParams.params['filter']['shop']
          }
        }
        this.requestUpdateForce++
      },
      changeDateRange (val) {
        if (val !== null) {
          let to = new Date(Date.now())
          to.setSeconds(59)
          to.setMinutes(59)
          to.setHours(23)
          this.requestParams.params['date_from'] = val
          this.requestParams.params['date_to'] = to.toISOString()
        } else {
          if (typeof this.requestParams.params['date_from'] !== 'undefined') {
            delete this.requestParams.params['date_from']
          }
          if (typeof this.requestParams.params['date_to'] !== 'undefined') {
            delete this.requestParams.params['date_to']
          }
        }
        this.requestUpdateForce++
      },
      searchAction () {
        if (this.paginatorPassive) {
          if (this.searchValue !== '') {
            this.requestParams.params['query'] = this.searchValue
          } else {
            delete this.requestParams.params['query']
          }
          this.requestUpdateForce++
        } else {
          this.search = this.searchValue
        }
      },
      sortBy (sortKey) {
        this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
        this.sortKey = sortKey
      },
      updatePageContent (content) {
        this.pageContent = content
      },
      highlight (words, query) {
        let iQuery = new RegExp(query, 'ig')
        return words.toString().replace(iQuery, (matchedTxt) => {
          return (`<span class="highlight">${matchedTxt}</span>`)
        })
      }
    },
    computed: {
      filteredList () {
        let filtered = this.list
        if (this.search !== '') {
          let pattern = new RegExp(this.search, 'i')
          filtered = filtered.filter((item) => {
            return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern)
          })
        }
        this.filteredCount = filtered.length
        return filtered
      },
      noContent () {
        return !(this.pageContent instanceof Array && this.pageContent.length)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/scss/settings";
    @import "../../assets/scss/utilities";

</style>



// WEBPACK FOOTER //
// CollectList.vue?a4472fee